import http from "../../utils/http";
import { toast } from "../../utils/toast";

// 휴가 신청 목록
export const getVacationsRequestList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/vacations/request/list", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 휴가 신청 등록
export const createVacationsRequest = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/vacations/request", body)
      .then((res) => {
        toast.success('휴가 신청이 완료되었습니다.')
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 휴가 신청 상세
export const getVacationsRequest = (requestIdx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/vacations/request/${requestIdx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 휴가 신청 티켓 삭제
export const deleteVacationsRequest = (requestIdx) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/vacations/request/${requestIdx}`)
      .then((res) => {
        toast.success('휴가 신청이 취소되었습니다.')
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
